import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import logoImage from "../assets/JBF_logo_white.svg";

const pagePathMap: Record<string, string> = {
  about: "/about",
  committee: "/committee",
  programs: "/programs",
  governance: "/governance",
  platform: "/platform",
  "hostel-directory": "/hostel-directory",
  donors: "/donors",
  vendors: "/vendors",
  knowledge: "/knowledge-hub",
  contact: "/contact",
  donation: "/donation",
};

export default function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (pageId: string) => {
    navigate(pagePathMap[pageId] ?? "/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="mt-0 bg-[#7A1E1E] text-white sm:mt-0 lg:mt-0">
      <div className="mx-auto max-w-[1400px] px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8 lg:grid-cols-4">
          {/* About Section */}
          <div>
            <div className="mb-3 w-40 sm:mb-4 sm:w-48">
              <img src={logoImage} alt="JBF Logo" className="h-auto w-full" />
            </div>
            <p className="mb-3 text-xs text-gray-200 sm:mb-4 sm:text-sm">
              Empowering Jain students with modern hostels, governance,
              transparency, and developmental excellence.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <button
                type="button"
                aria-label="Facebook"
                className="transition-colors hover:text-[#D4A017]"
              >
                <Facebook size={20} />
              </button>
              <button
                type="button"
                aria-label="Twitter"
                className="transition-colors hover:text-[#D4A017]"
              >
                <Twitter size={20} />
              </button>
              <button
                type="button"
                aria-label="LinkedIn"
                className="transition-colors hover:text-[#D4A017]"
              >
                <Linkedin size={20} />
              </button>
              <button
                type="button"
                aria-label="Instagram"
                className="transition-colors hover:text-[#D4A017]"
              >
                <Instagram size={20} />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-3 text-base text-[#D4A017] sm:mb-4 sm:text-lg">
              Quick Links
            </h3>
            <ul className="space-y-1.5 text-xs sm:space-y-2 sm:text-sm">
              <li>
                <button
                  onClick={() => handleNavClick("about")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  About JBF
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("programs")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Programs & Initiatives
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("donation")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Donation
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("governance")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Governance Model
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("platform")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Digital Platform
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("hostel-directory")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Institution Directory
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="mb-4 text-lg text-[#D4A017]">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => handleNavClick("donors")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Donors & CSR
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("vendors")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Vendors & Experts
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("knowledge")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Knowledge Hub
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("contact")}
                  className="transition-colors hover:text-[#D4A017]"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-3 text-base text-[#D4A017] sm:mb-4 sm:text-lg">
              Contact Us
            </h3>
            <ul className="space-y-2 text-xs sm:space-y-3 sm:text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>
                  Jain Boarding Federation
                  <br />
                  {/* National Office
                  <br /> */}
                  B-208, (South Wing) Malad Shopping Centre,
                  <br />
                  S. V. Road, Malad (West)
                  <br />
                  Mumbai - 400064, India
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} />
                <span>+91 81690 74905</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} />
                <span>info@jbf.org.in</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 border-t border-[#9A3E3E] pt-8 text-center text-sm text-gray-200">
          <p>
            &copy; {new Date().getFullYear()} Jain Boarding Federation. All
            rights reserved.
          </p>
          {/* <p className="mt-2">
            Powered by S-ARDA Governance Framework | Partnership with Mehta Atre
            & Associates
          </p> */}
        </div>
      </div>
    </footer>
  );
}
